import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import promotion from '../../../promotion_config';
import { mapStateToProps, mapDispatchToProps } from '../../../src/Store';
import {  isBrowser } from '../../utils';

export const LoginButton = ({ config }) => {
    let myLocation = isBrowser() ? location.protocol + '//' + location.host + location.pathname : '';
    const [configLoginUrl, setConfigLoginUrl] = useState(config.config ? config.config.login_host_uri : '');

    useEffect(() => {
        config.config ? setConfigLoginUrl(config.config.login_host_uri) : '';
    }, [config.config]);

    // remove any trailing slashes
    myLocation = myLocation.replace(/\/$/, '');
    const defaultLoginUrl = promotion.getLoginLink(myLocation, myLocation);
    const loginUrl = isBrowser() && configLoginUrl ? `${configLoginUrl}?PtaUrl=${myLocation}&Redirect=${myLocation}` : defaultLoginUrl;

    if (isBrowser()) {
        let vipNav = document.getElementById('nav-vip');
        return ReactDOM.createPortal(
            <a href={loginUrl} className='btn btn-vip btn-vip-login' id='btn-vip-login'>
                <span className='accessible-text'>VIP Players Club</span> Login
            </a>,
            vipNav
        );
    } else {
        return null;
    }
};

export const MyVip = ({ clicked, toggle }) => {
    if (isBrowser()) {
        let vipNav = document.getElementById('nav-vip');
        let buttonClass = '';

        if (toggle) {
            buttonClass = 'sub-nav-showing';
        }

        return ReactDOM.createPortal(
            <button aria-haspopup='true' aria-expanded='true' className={`btn btn-vip-menu ${buttonClass}`} onClick={clicked}>
                <span>My VIP</span>
            </button>,
            vipNav
        );
    } else {
        return null;
    }
};

export const JoinBtn = ({ config }) => {
    const [registerUrl, setRegisterUrl] = useState(config.config ? config.config.registration_host_uri : '');

    useEffect(() => {
        config.config ? setRegisterUrl(config.config.registration_host_uri) : '';
    }, [config.config]);

    if (isBrowser()) {
        let vipNav = document.getElementById('nav-vip');

        return ReactDOM.createPortal(
            <a href={registerUrl} className='btn btn-join' id='btn-join'>
                <i className='fas fa-user-plus'></i>
                &nbsp;Join
            </a>,
            vipNav
        );
    } else {
        return null;
    }
};

const LogoutButton = ({ user, actions, config }) => {
    const ilottery_host = 'https://www.pailottery.com/';
    const lottery_host = 'https://palottery.pa.gov/';
    const [configLogOutUrl, setConfigLogOutUrl] = useState(config.config ? config.config.logout_host_uri : '');
    const [isActive, setActive] = useState(false);

    useEffect(() => {
        config.config ? setConfigLogOutUrl(config.config.logout_host_uri) : '';
    }, [config.config]);

    const logoutClick = async (e) => {
        await actions.userActions.logout();
    };

    const toggleClass = () => {
        setActive(!isActive);
    };

    if (isBrowser()) {
        let vipNav = document.getElementById('nav-vip');

        const primaryMenuItemUrlDomain = config?.config?.partner_map?.ilottery_host || ilottery_host;
        const secondaryMenuItemUrlDomain = config?.config?.lottery_host || lottery_host;

        return ReactDOM.createPortal(
            <div className='nav-top-more nav-primary-more row flex' role='menu' id='subnav-my-vip' style={{ display: 'flex' }}>
                <nav className='subnav-vert'>
                    <a href={primaryMenuItemUrlDomain + 'cashier/'} className='subnav-vert-item'>
                        Cashier
                    </a>
                    <a href={primaryMenuItemUrlDomain + 'login/change-password/'} className='subnav-vert-item'>
                        Login Details
                    </a>
                    <a href={primaryMenuItemUrlDomain + 'documents/'} className='subnav-vert-item'>
                        My Documents
                    </a>
                    <a href={primaryMenuItemUrlDomain + 'my-drawings/'} id='p_lt_ctl00_LotteryMobileMenu_kycNavMyDrawings' className='subnav-vert-item'>
                        My Drawings
                    </a>
                    <a href={primaryMenuItemUrlDomain + 'my-subscriptions/'} className='subnav-vert-item'>
                        My Subscriptions
                    </a>
                    <a href={primaryMenuItemUrlDomain + 'responsible/gaming-limits/'} className='subnav-vert-item'>
                        Responsible Gaming
                    </a>
                    <a href={primaryMenuItemUrlDomain + 'contact-preferences/'} className='subnav-vert-item'>
                        Contact Preferences
                    </a>

                    <button id='btn-vip-players-club' className='btn btn-subnav-vert' onClick={toggleClass}>
                        VIP Players Club <i className='fas fa-angle-right'></i>
                    </button>
                    <div className={isActive ? 'subnav-vert switchable-nav subnav-on' : 'subnav-vert switchable-nav subnav-off'} id='subnav-vip-players-club'>
                        <h3>VIP Players Club</h3>
                        <a href={secondaryMenuItemUrlDomain + 'VIP-Players-Club/Dashboard.aspx'} className='subnav-vert-item'>
                            Go to VIP Dashboard
                        </a>
                        <a href={secondaryMenuItemUrlDomain + 'VIP-Players-Club/Second-Chance-Prize-Zone.aspx'} className='subnav-vert-item'>
                            Second Chance&trade;
                        </a>
                        <a href={secondaryMenuItemUrlDomain + 'VIP-Players-Club/Coupon-Offers.aspx'} className='subnav-vert-item'>
                            Coupon Offers
                        </a>
                        <a href={secondaryMenuItemUrlDomain + 'VIP-Players-Club/My-VIP/Edit-Email-Alerts.aspx'} className='subnav-vert-item'>
                            Email Alerts
                        </a>
                        <a href={secondaryMenuItemUrlDomain + 'VIP-Players-Club/My-VIP/Edit-Text-Alerts.aspx'} className='subnav-vert-item'>
                            Text Alerts
                        </a>
                        <a href={secondaryMenuItemUrlDomain + 'VIP-Players-Club/My-VIP/My-Numbers.aspx'} className='subnav-vert-item'>
                            My Numbers
                        </a>
                        <button id='btn-back-to-main' className='btn btn-subnav-vert' onClick={toggleClass}>
                            <i className='fas fa-angle-left'></i> Main Menu
                        </button>
                    </div>
                </nav>
                <div className='details-vert'>
                    <div className='row subnav-content'>
                        <div id='vip-details'>
                            <p>
                                <span className='account-title'>Signed in as</span>
                                <a href={configLogOutUrl} className='btn btn-alt btn-logout' onClick={logoutClick}>
                                    Log Out
                                </a>
                                <span className='account-owner'>{user.player ? user.player.first_name : null}</span>
                                <span className='account-owner'>{user.player ? user.player.last_name : null}</span>
                                <span className='account-email'>{user.player ? user.player.email : null}</span>
                            </p>
                        </div>
                    </div>
                    <a href={primaryMenuItemUrlDomain + 'login/welcome-back/'} className='lnk-back'>
                        Back to Account Overview
                    </a>
                </div>
            </div>,
            vipNav
        );
    } else {
        return null;
    }
};

const WelcomeHandler = ({ config, user, loading, actions }) => {
    const [hasMounted, setHasMounted] = useState(false);
    const [vipToggle, setVipToggle] = useState(false);

    useEffect(() => {
        setHasMounted(true);
    }, []);

    const showLogout = (user, actions, config) => {
        return <LogoutButton user={user} actions={actions} config={config} />;
    };

    if (!hasMounted || loading.actions['getPlayerData'] || loading.actions['getConfig'] || loading.actions['login']) {
        return (
            <>
                <LoginButton config={config} />
                <JoinBtn config={config} />
            </>
        );
    } else {
        if (user.loggedIn) {
            return (
                <>
                    <MyVip config={config} clicked={() => setVipToggle(!vipToggle)} toggle={vipToggle} />
                    {vipToggle ? showLogout(user, actions, config) : null}
                </>
            );
        } else {
            return (
                <>
                    <LoginButton config={config} />
                    <JoinBtn config={config} />
                </>
            );
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(WelcomeHandler);
